import { render, staticRenderFns } from "./warnTip.vue?vue&type=template&id=51538630&scoped=true&"
import script from "./warnTip.vue?vue&type=script&lang=js&"
export * from "./warnTip.vue?vue&type=script&lang=js&"
import style0 from "./warnTip.vue?vue&type=style&index=0&id=51538630&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51538630",
  null
  
)

export default component.exports